import { categories, featuredTracks } from './asmr';

export interface TrackItem {
  id: string;
  title: string;
  category: string;
  categoryName: string;
  duration: string;
  listens: number;
  description: string;
}

export const tracksByCategory: Record<string, TrackItem[]> = {
  zhumian: [
    ...featuredTracks.filter((t) => t.category === 'zhumian'),
    {
      id: 'zhumian-2', title: '温柔耳语哄睡', category: 'zhumian', categoryName: '助眠', duration: '28:40', listens: 92300,
      description: '温柔的轻声耳语，配合舒缓的呼吸节奏，让您渐渐进入深度睡眠状态。',
    },
    {
      id: 'zhumian-3', title: '翻页声助眠', category: 'zhumian', categoryName: '助眠', duration: '35:10', listens: 78500,
      description: '缓慢的翻页声、纸张摩擦声，仿佛有人在旁边安静地阅读，带来安心感。',
    },
    {
      id: 'zhumian-4', title: '轻柔敲击音', category: 'zhumian', categoryName: '助眠', duration: '22:15', listens: 67100,
      description: '指甲轻柔敲击木质表面的声音，规律而舒缓，有效帮助放松入眠。',
    },
    {
      id: 'zhumian-5', title: '睡前故事朗读', category: 'zhumian', categoryName: '助眠', duration: '45:00', listens: 58900,
      description: '温柔的中文睡前故事朗读，声音平缓柔和，带您进入童话般的梦乡。',
    },
    {
      id: 'zhumian-6', title: '揉搓音助眠', category: 'zhumian', categoryName: '助眠', duration: '30:20', listens: 53400,
      description: '双手揉搓、按摩的声音，干燥而温和的摩擦音让紧绷的神经逐渐松弛。',
    },
  ],
  jieya: [
    ...featuredTracks.filter((t) => t.category === 'jieya'),
    {
      id: 'jieya-2', title: '键盘敲击减压', category: 'jieya', categoryName: '解压', duration: '24:30', listens: 81200,
      description: '清脆的机械键盘敲击声，节奏明快，有效释放积压的压力和紧张情绪。',
    },
    {
      id: 'jieya-3', title: '沙沙揉纸音', category: 'jieya', categoryName: '解压', duration: '20:15', listens: 69800,
      description: '揉搓纸张的沙沙声，配合轻柔的手指摩擦音，带来极致的触觉想象体验。',
    },
    {
      id: 'jieya-4', title: '水晶碰撞音', category: 'jieya', categoryName: '解压', duration: '18:50', listens: 63700,
      description: '水晶、玻璃等清脆材质的碰撞声，清亮的音色让人心情愉悦、压力消散。',
    },
    {
      id: 'jieya-5', title: '耳畔轻语解压', category: 'jieya', categoryName: '解压', duration: '32:00', listens: 56200,
      description: '近距离的温柔耳语，各种触发音交织，营造被呵护的安心感受。',
    },
    {
      id: 'jieya-6', title: '泡泡纸捏捏乐', category: 'jieya', categoryName: '解压', duration: '15:40', listens: 48100,
      description: '连续捏爆泡泡纸的声音，每个泡泡的破裂都带走一份压力，极度解压。',
    },
  ],
  zhuanzhu: [
    ...featuredTracks.filter((t) => t.category === 'zhuanzhu'),
    {
      id: 'zhuanzhu-2', title: '咖啡馆环境音', category: 'zhuanzhu', categoryName: '专注', duration: '50:00', listens: 72300,
      description: '低沉的咖啡馆背景声，杯碟轻碰、低声交谈，打造理想的专注工作环境。',
    },
    {
      id: 'zhuanzhu-3', title: '笔尖书写音', category: 'zhuanzhu', categoryName: '专注', duration: '38:20', listens: 65400,
      description: '钢笔在纸上书写的沙沙声，规律的节奏助您沉浸于学习与创作之中。',
    },
    {
      id: 'zhuanzhu-4', title: '风扇白噪音', category: 'zhuanzhu', categoryName: '专注', duration: '60:00', listens: 58900,
      description: '稳定均匀的风扇转动声，完美的背景噪音，屏蔽突如其来的环境干扰。',
    },
    {
      id: 'zhuanzhu-5', title: '时钟滴答声', category: 'zhuanzhu', categoryName: '专注', duration: '45:00', listens: 51700,
      description: '老式时钟的滴答声，规律的节奏如同心跳，帮助进入高效的心流状态。',
    },
    {
      id: 'zhuanzhu-6', title: '静谧办公室音', category: 'zhuanzhu', categoryName: '专注', duration: '55:00', listens: 46200,
      description: '安静的办公室环境音，偶尔的键盘声和翻页声，还原高效工作氛围。',
    },
  ],
  baizaoyin: [
    ...featuredTracks.filter((t) => t.category === 'baizaoyin'),
    {
      id: 'baizaoyin-2', title: '纯正白噪音', category: 'baizaoyin', categoryName: '白噪音', duration: '60:00', listens: 89300,
      description: '经过专业均衡处理的纯正白噪音，全频段覆盖，有效屏蔽各种环境干扰。',
    },
    {
      id: 'baizaoyin-3', title: '棕色噪音深度睡眠', category: 'baizaoyin', categoryName: '白噪音', duration: '60:00', listens: 75600,
      description: '低频丰富的棕色噪音，声音深沉浑厚，特别适合深度睡眠和冥想放松。',
    },
    {
      id: 'baizaoyin-4', title: '灰色噪音均衡', category: 'baizaoyin', categoryName: '白噪音', duration: '45:00', listens: 61200,
      description: '经过心理声学调校的灰色噪音，在所有频率上听起来同样响亮，体验独特。',
    },
  ],
  ziranyin: [
    ...featuredTracks.filter((t) => t.category === 'ziranyin'),
    {
      id: 'ziranyin-2', title: '海边浪潮声', category: 'ziranyin', categoryName: '自然音', duration: '50:00', listens: 94300,
      description: '海浪拍打沙滩的声音，一浪接一浪的节奏，如同大自然的摇篮曲。',
    },
    {
      id: 'ziranyin-3', title: '森林清晨鸟鸣', category: 'ziranyin', categoryName: '自然音', duration: '40:00', listens: 82700,
      description: '清晨森林中的鸟鸣声，微风穿过树叶的沙沙声，唤醒一天的好心情。',
    },
    {
      id: 'ziranyin-4', title: '山涧溪流声', category: 'ziranyin', categoryName: '自然音', duration: '55:00', listens: 73500,
      description: '清澈的山涧溪水潺潺流淌，水流撞击石头发出的悦耳声音，沁人心脾。',
    },
    {
      id: 'ziranyin-5', title: '夏日雷雨声', category: 'ziranyin', categoryName: '自然音', duration: '45:00', listens: 68400,
      description: '远处的雷鸣、密集的雨声、偶尔的闪电，震撼而治愈的夏日雷雨体验。',
    },
    {
      id: 'ziranyin-6', title: '篝火燃烧声', category: 'ziranyin', categoryName: '自然音', duration: '35:00', listens: 59800,
      description: '木柴在篝火中噼啪燃烧的声音，温暖而安心，仿佛围坐在篝火旁。',
    },
  ],
  mingxiang: [
    ...featuredTracks.filter((t) => t.category === 'mingxiang'),
    {
      id: 'mingxiang-2', title: '颂钵冥想', category: 'mingxiang', categoryName: '冥想', duration: '42:00', listens: 61200,
      description: '尼泊尔颂钵的悠远回响，声波振动穿透全身，引导您进入深度冥想。',
    },
    {
      id: 'mingxiang-3', title: '风铃禅意', category: 'mingxiang', categoryName: '冥想', duration: '36:30', listens: 54800,
      description: '微风拂过风铃的清脆声音，禅意十足，让心灵归于宁静与平和。',
    },
    {
      id: 'mingxiang-4', title: '水滴空灵音', category: 'mingxiang', categoryName: '冥想', duration: '38:00', listens: 49700,
      description: '水滴落入深潭的空灵回响，在寂静的空间中荡漾，净化心灵的杂念。',
    },
    {
      id: 'mingxiang-5', title: '西藏音钵疗愈', category: 'mingxiang', categoryName: '冥想', duration: '48:00', listens: 45300,
      description: '西藏传统音钵疗愈音乐，深厚的泛音共振，平衡身体的七个脉轮能量。',
    },
    {
      id: 'mingxiang-6', title: '古琴冥想曲', category: 'mingxiang', categoryName: '冥想', duration: '40:00', listens: 41200,
      description: '中国传统古琴演奏的冥想曲，琴音悠远绵长，带领心灵进入禅定境界。',
    },
  ],
};

export function getCategoryBySlug(slug: string) {
  return categories.find((c) => c.slug === slug);
}

export function getTracksBySlug(slug: string): TrackItem[] {
  return tracksByCategory[slug] || [];
}

export function getCategoryTitle(slug: string): string {
  const cat = getCategoryBySlug(slug);
  return cat ? cat.name : '';
}